<template>
  <div class="nav-bar mb-2">
    <button v-if="!hideButton" class="bg-transparent" @click="goBack">
      <font-awesome-icon class="icon" icon="fa-solid fa-arrow-left"></font-awesome-icon>
    </button>
    <h4 >{{ title }}</h4>
  </div>
</template>

<script>
export default {
  name: "BackNavigationBar",
  props: {
    title: {
      type: String,
      default: ''
    },hideButton:{
      type: Boolean,
      default: false
    },
    back: {
      type: Function,
    }
  },
  methods: {
    goBack() {
      if (this.back) {
        this.back();
      } else {
        this.$router.back()
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.nav-bar {
  display: inline-flex;
  margin-top: 0px;
  gap: 20px;
  height: 50px;
  align-items: center;
  width: 100%;
  padding: 0 15px;
  top: 0;
  right: 0;
  left: 0;
  background: var(--card-bg);
  position: sticky;
  box-shadow: var(--card-shadow);
  z-index: 1;
  transition: background-color 0.8s ease, box-shadow 0.8s ease;

  .icon {
    font-size: 25px;
    color: var(--text-primary);
    transition: color 0.8s ease;
  }

  h4 {
    margin: 0;
    font-weight: 600;
    text-overflow: ellipsis;
    color: var(--text-primary);
    transition: color 0.8s ease;
  }

}
</style>
